import React from "react";
import { useState, useEffect, useContext } from "react";
import { getSondage, getCompleteClientInfo } from "../api";
import { RedirectUrlValue } from "../../context/RedirectUrlValue";

export default function ResultSondage() {
    const [data, setData] = useState([]);
    const [totalForms, setTotalForms] = useState({});
    const { brand } = useContext(RedirectUrlValue);
    const [module, setModule] = useState([]);
    const [visibleDetails, setVisibleDetails] = useState({});
    const [questionValue, setQuestionValue] = useState("");

    useEffect(() => {
        getSondage().then((data) => {
            const filteredData = data.filter(
                (item) => item.data[0].client.toLowerCase() === brand
            );

            setData(filteredData);

            const counts = {};
            filteredData.forEach((item) => {
                const boutique = item.data[0].Boutique;
                const theme = item.data[0].theme;

                if (theme.toLowerCase() === "note") return;

                if (!counts[boutique]) {
                    counts[boutique] = new Set();
                }

                counts[boutique].add(theme);
            });

            const result = {};
            for (const [boutique, themes] of Object.entries(counts)) {
                result[boutique] = themes.size;
            }

            setTotalForms(result);
        });
    }, [brand]);

    useEffect(() => {
        module.forEach((item) => {
            if (item.title === "Audit") {
                setQuestionValue(item.dataQuestion);
            }
        });
    }, [module]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { moduleData } = await getCompleteClientInfo(brand);
                setModule(moduleData);
            } catch (error) {
                console.error("Erreur lors de la récupération des modules.");
            }
        };
        fetchData();
    }, [brand]);

    const toggleDetail = (key, theme) => {
        setVisibleDetails((prev) => ({
            ...prev,
            [`${key}_${theme}`]: !prev[`${key}_${theme}`],
        }));
    };

    return (
        <>
            <h1>Résultat des sondage {brand}</h1>
            <div className="resultSondageContainer">
                {Object.entries(totalForms).map(([key, item]) => {
                    const filteredByBoutique = data.filter(
                        (el) =>
                            el.data[0].Boutique.toLowerCase() ===
                            key.toLowerCase()
                    );

                    const filteredThemes = filteredByBoutique.filter(
                        (el) => el.data[0].theme.toLowerCase() !== "note"
                    );

                    const uniqueThemes = [
                        ...new Set(
                            filteredThemes.map((el) => el.data[0].theme)
                        ),
                    ];

                    return (
                        <div className="containerResult" key={key}>
                            <p>{key}</p>
                            <p>{item} / 5</p>

                            <div className="themeDetails">
                                {uniqueThemes.map((theme, i) => {
                                    const detailKey = `${key}_${theme}`;
                                    const sondages = filteredByBoutique
                                        .filter(
                                            (el) => el.data[0].theme === theme
                                        )
                                        .flatMap((el) => el.data[0].sondage);

                                    return (
                                        <div
                                            key={i}
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                marginBottom: "6px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-between",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <span>{theme}</span>
                                                <button
                                                    onClick={() =>
                                                        toggleDetail(key, theme)
                                                    }
                                                    style={{
                                                        background: "none",
                                                        border: "none",
                                                        cursor: "pointer",
                                                        fontSize: "1.2rem",
                                                    }}
                                                >
                                                    ☰
                                                </button>
                                            </div>
                                            {visibleDetails[detailKey] && (
                                                <ul
                                                    style={{
                                                        marginLeft: "10px",
                                                    }}
                                                >
                                                    {questionValue &&
                                                        questionValue[
                                                            Object.keys(
                                                                questionValue
                                                            ).find(
                                                                (key) =>
                                                                    questionValue[
                                                                        key
                                                                    ].title.toLowerCase() ===
                                                                    theme.toLowerCase()
                                                            )
                                                        ]?.data.map(
                                                            (question, idx) => (
                                                                <li key={idx}>
                                                                    {question} :{" "}
                                                                    {sondages[
                                                                        idx
                                                                    ] ?? "-"}
                                                                </li>
                                                            )
                                                        )}
                                                    <li
                                                        style={{
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        Moyenne :{" "}
                                                        {(
                                                            sondages.reduce(
                                                                (sum, val) =>
                                                                    sum +
                                                                    Number(val),
                                                                0
                                                            ) / sondages.length
                                                        ).toFixed(2)}{" "}
                                                        / 5
                                                    </li>
                                                </ul>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
}
